document.addEventListener('DOMContentLoaded', () => {
  // background-image
  // enable background declaration style via data attributes for url, posx, posy
  const bgImages = document.querySelectorAll('.bg-image');
  bgImages.forEach((bgImage) => {
    const bgImageUrl = bgImage.getAttribute('data-image-src');
    const bgPosX = bgImage.getAttribute('data-posx');
    const bgPosY = bgImage.getAttribute('data-posy');
    const bgSize = bgImage.getAttribute('data-size');
    bgImage.style.background = `url(${bgImageUrl}) no-repeat ${bgPosX} ${bgPosY}/${bgSize}`;
  });

  // gradient
  // enable background declaration style via data attribute for gradients
  const gradients = document.querySelectorAll('.gradient');
  gradients.forEach((gradient) => {
    const gradientOverlay = gradient.getAttribute('data-gradient');
    gradient.style.background = gradientOverlay;
  });

  // BOTH background-image AND gradient
  // enable background declaration style via data attributes for linear-gradient, url, posx, posy
  const bgImageGradients = document.querySelectorAll('.bg-image-gradient');
  bgImageGradients.forEach((bgImageGradient) => {
    const gradient = bgImageGradient.getAttribute('data-gradient');
    const bgImageUrl = bgImageGradient.getAttribute('data-image-src');
    const bgPosX = bgImageGradient.getAttribute('data-posx');
    const bgPosY = bgImageGradient.getAttribute('data-posy');
    const bgSize = bgImageGradient.getAttribute('data-size');
    bgImageGradient.style.background = `${gradient}url(${bgImageUrl}) no-repeat ${bgPosX} ${bgPosY}/${bgSize}`;
  });
});

